export default __webpack_public_path__ + "imgs/beTogether04.ecd539e.jpeg";